import axios from "axios";
import { navigatePromise } from "../router";
import { API_BASE_URL } from "./apiUrl";
import { AUTH_REFRESH_REQUESTED_EVENT, clearCurrentUser } from "./user";

const TOKEN_KEY = "access_token";

const request = axios.create({
  baseURL: API_BASE_URL,
});

export async function handleUnauthorized() {
  localStorage.removeItem(TOKEN_KEY);
  clearCurrentUser();
  const navigate = await navigatePromise;
  navigate("/login", { replace: true });
}

// 请求拦截器：自动携带 token，并固定 Accept-Language 为英文
request.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.headers["Accept-Language"] = "en-US";
  return config;
});

// 响应拦截器：401 时清除登录状态并跳转登录页
request.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      await handleUnauthorized();
    } else if (error.response?.status === 403) {
      window.dispatchEvent(new Event(AUTH_REFRESH_REQUESTED_EVENT));
    }
    return Promise.reject(error);
  },
);

export { TOKEN_KEY };
export default request;
